const MSSK = {
  mssk_01: ['Обозначение типа локализации'],
  mssk_02: ['Обозначение типа локализации'],
  mssk_03: ['Функциональное назначение', 'Класс функциональной пожарной опасности'],
  mssk_04: ['Синхронизация по ОКВЭД 2017'],
  mssk_05: ['S квартиры', 'Общая S квартиры'],
  mssk_06: [],
  mssk_07: ['Класс IFC'],
  mssk_08: ['Синхронизация по ОКПД2'],
  mssk_09: ['Шифр ресурса ТСН', 'Синхронизация по ОКПД2'],
  mssk_10: ['Аббревиатура'],
  mssk_11: [],
  mssk_12: ['Объект параметра'],
  mssk_13: ['Синхронизация с ТСН-2001', 'Объект применения (МССК Элементы)', 'Метод изготовления'],
};

export { MSSK };
